import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Leaves } from 'shared/lib/types';

import { RoleDto } from 'entities/role';

type ObjectLeaves = Leaves<RoleDto>;

export type TableColumns = Extract<ObjectLeaves, 'name'>;

export type TableColumnsState = Record<TableColumns, boolean>;

const initialState: TableColumnsState = {
  name: true,
};

const slice = createSlice({
  name: 'rolesTable',
  initialState,
  reducers: {
    setVisibleColumns: (state, action: PayloadAction<TableColumnsState>) => {
      return action.payload;
    },
  },
});

export const { setVisibleColumns } = slice.actions;
export default slice.reducer;
